import React, { useEffect, useState } from "react";
import { GetReferralReportApi } from "../../../api/request/reports/report";
import columns from "../../../columns/reports/referralUsersReport";
import SkeletonTable from "../../../components/table/SkeletonTable";

export default function ReferralReport() {
  const [referralList, setReferralList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getReferralReportList = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetReferralReportApi();
      if (data?.status) {
        setReferralList(
          data?.data?.map((item) => {
            return {
              ...item,
              status: (
                <p className="text-green-500 font-bold uppercase">
                  {item?.status}
                </p>
              ),
              children:
                item?.referral_users?.length > 0
                  ? item?.referral_users?.map((child) => ({
                    ...child,
                    status: (
                      <p className="text-green-500 font-bold uppercase">
                        {child?.status}
                      </p>
                    ),
                  }))
                  : null,
            };
          })
        );
      }

      setIsLoading(false);
    } catch (error) {
      setReferralList([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getReferralReportList();
  }, []);

  return (
    <div className="border-2 rounded-xl my-5">
      <div className="flex justify-between mx-5 mt-5">
        <p className=" font-semibold text-2xl">Referral Users Reports</p>
      </div>
      <div className="my-6">
        <SkeletonTable
          searchingFields={["name", "email"]}
          columns={columns}
          data={referralList}
          isLoading={isLoading}
          pagination={true}
        />
      </div>
    </div>
  );
}
